import React from 'react';

export function StepSummaryLabel() {
  return <>Potvrzení registrace</>;
}
